export default __webpack_public_path__ + "images/b78ebc122a4bee1544b431921164cb4b.svg";